import React from "react";
import AddEditCharges from "../../../Components/AddEditBooking/AddEditCharges";
import {
  useAddPaymentMutation,
  useOrderByIdQuery,
  usePaymentByIdQuery,
} from "../../../Store/Apis/bookingApi";
import { updateReservation } from "../../../Store/Apis/ReservationApi";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
// import { EditCharges } from '../../AllPages';

const EditCharges = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const orderId = queryParams.get("id");
  const outletId = queryParams.get("outletID");
  // Send both orderID and outletID to GetReservations3
  const orderByIdApi = useOrderByIdQuery({
    orderID: Number(orderId),
    outletID: Number(outletId),
  });

  const paymentByIdApi = usePaymentByIdQuery({
    orderId: Number(orderId),
  });

  const [addPaymentMutation] = useAddPaymentMutation();

  const handleSubmit = (formData) => {
    console.log(formData);
    // addPaymentMutation({
    //     paymentDate: new Date().toISOString(),
    //     customerId: orderByIdApi.data.data[0].customerID,
    //     customerName: orderByIdApi.data.data[0].customerName,
    //     orderId: Number(orderId),
    //     payAmount: formData.paidAmount || 0 ,
    //     receivedAmount: formData.receivedAmount || 0,
    //     paymentType: formData.paymentType,
    //     paymentNote: formData.notes || '',
    //     utrNumber: formData.utrNumber
    // })

    // Map to UpdateReservations payload
    const baseOrder = orderByIdApi?.data?.data?.[0] || {};
    const newServices = (formData?.serviceDetails || []).filter(
      (s) => !(s?.orderDetailPrimaryID || s?.keyID || s?.keyId)
    );
    const orderDetails = newServices.map((s) => {
      const nights = Number(s.nights ?? s.nightCount ?? 1) || 1;
      const rate = Number(s.serviceRate ?? s.rate ?? 0) || 0;
      const parentIdVal = s.parentID ?? s.parentId ?? s.serviceId ?? 0;
      const typeIdVal = s.typeID ?? s.typeId ?? s.serviceTypeID ?? 0;
      const qty = Number(s.serviceQuantity ?? s.quantity ?? 1) || 1;
      const total = Number(
        s.detailPrice ?? rate * qty * (Number(s.nights ?? 1) || 1)
      );
      return {
        serviceID: parentIdVal,
        serviceTypeID: typeIdVal,
        typeID: typeIdVal,
        nightCount: Number(s.nights ?? nights ?? 0) || 0,
        serviceQuantity: qty,
        defectedQuantity: 0,
        servicePrice: rate,
        detailPrice: total,
        parentID: parentIdVal,
        serviceDetailTotal: total,
        brandID: 0,
        length: 0,
        breadth: 0,
        colorCode: 0,
        orderDetailPrimaryID: 0,
      };
    });

    const displayedSubtotal = orderDetails.reduce(
      (sum, od) => sum + (Number(od.detailPrice) || 0),
      0
    );

    const payload = {
      orderID: Number(orderId),
      phoneNumber: formData.phoneNumber ?? baseOrder.customerNumber ?? "",
      orderDate: formData.orderDate
        ? new Date(formData.orderDate).toISOString()
        : new Date().toISOString(),
      checkOutDate: baseOrder?.checkOutDate
        ? new Date(baseOrder.checkOutDate).toISOString()
        : undefined,
      subTotal: displayedSubtotal,
      discountType: formData.discountType ?? baseOrder?.discountType ?? 0,
      discount: Number(formData.discount ?? baseOrder?.discount ?? 0),
      taxPercentage: Number(baseOrder?.taxPercentage ?? 0),
      taxAmount: Number(baseOrder?.taxAmount ?? 0),
      total: displayedSubtotal,
      note: baseOrder?.notes ?? "",
      instruction: baseOrder?.instruction ?? "",
      status: formData.statusId ?? baseOrder?.statusID ?? 0,
      paymentDate: new Date().toISOString(),
      receivedAmount: Number(formData.receivedAmount ?? 0),
      payAmount: Number(formData.paidAmount ?? formData.receivedAmount ?? 0),
      paymentType: formData.paymentType ?? baseOrder?.paymentType ?? 0,
      paymentNote: formData.paymentNote ?? baseOrder?.paymentNote ?? "",
      orderDetails,
      subCustomers: baseOrder?.subCustomers || [],
    };

    updateReservation(payload)
      .then((res) => {
        if (res?.status >= 200 && res?.status < 300) {
          toast.success(res?.message || "Reservation updated", {
            duration: 7000,
          });
        } else {
          toast.error(res?.message || "Failed to update reservation", {
            duration: 7000,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something Went Wrong !!", { duration: 7000 });
      });
  };

  return (
    <div>
      {orderByIdApi.isSuccess && paymentByIdApi.isSuccess && (
        <AddEditCharges
          data={orderByIdApi?.data?.data[0]}
          paymentData={{
            discountType: orderByIdApi?.data?.data[0].discountType,
            discount: orderByIdApi?.data?.data[0].discount,
            paidAmount: orderByIdApi?.data?.data[0].amountPaid,
            paymentType: paymentByIdApi?.data?.data[0].paymentType,
            utrNumber: paymentByIdApi?.data?.data[0].utrNumber,
            notes: paymentByIdApi?.data?.data[0].notes,
            specialInstruction: "",
          }}
          onSubmit={handleSubmit}
        />
      )}
    </div>
  );
};

export default EditCharges;
